import { el } from "@dhx/ts-common/dom";
import { Label } from "./helper/label";
import { getFormItemCss, getValidationMessage, isEmptyObj } from "../helper";
import { IEventSystem, EventSystem } from "@dhx/ts-common/events";
import { ValidationStatus, ISelect, BaseElementEvent, IBaseSelectEventHandlersMap } from "../types";


export class Select extends Label {
	public config: ISelect;
	public events: IEventSystem<BaseElementEvent, IBaseSelectEventHandlersMap> = new EventSystem();

	constructor(config: ISelect) {
		super(null, config);
		this.setConfig(config);
	}
	validate(): boolean {
		const { required, value, validation } = this.config;
		let isValid = true;
		isValid = validation
			? this.config.validation(value)
			: !required || Boolean(value);
		this.config.$validationStatus = isValid
			? ValidationStatus.success
			: ValidationStatus.error;
		this.paint();
		return isValid;
	}
	clearValidate(): void {
		this.config.$validationStatus = ValidationStatus.pre;
		this.paint();
	}
	clear(): void {
		this.config.value = this.config.options[0].value;
		this.paint();
	}
	setValue(value: string): void {
		this.config.value = value;
		this.events.fire(BaseElementEvent.change, [value]);
		this.paint();
	}
	setConfig(config: ISelect): void {
		if (isEmptyObj(config)) {
			return;
		}
		this.config = {
			type: this.config.type,
			id: this.config.id,
			name: this.config.name,
			options: config.options,
			value: config.options[0].value
		};
		for (const key in config) {
			if (key !== "id" && key !== "type" && key !== "name") {
				this.config[key] = config[key];
			}
		}
		this.events.fire(BaseElementEvent.configUpdate, [this.config]);
		this.paint();
	}
	getValue(): string {
		return this.config.value || "";
	}
	protected _getHandlers() {
		return {
			onchange: (e: Event) => {
				const value = (e.target as HTMLSelectElement).value;
				this.config.value = value;
				this.events.fire(BaseElementEvent.change, [value]);
				this.validate();
			}
		};
	}
	protected _draw() {
		const { id, options, icon, required, value, validation } = this.config;
		return el(".dhx_form-group", {
			class: getFormItemCss(this.config, Boolean(required) || Boolean(validation))
		},[
			this._drawLabel(),
			el(".dhx_input__wrapper", {
			},[
				el("div.dhx_input__container", {
				}, [
					el(".dhx_input__icon", {
						class: icon ? icon : "dxi dxi-menu-down"
					}),
					el("select", {
						id,
						class: "dhx_select dhx_input",
						onchange: this._handlers.onchange
					},
						options && options.map(option => el("option", {
							value: option.value,
							disabled: option.disabled,
							selected: option.selected || value === option.value,
						}, option.content)),
					),
				]),
				getValidationMessage(this.config) && el("span.dhx_input__caption", getValidationMessage(this.config))
			]),
		]);
	}
}
